// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"149fca94","352":"aefdfcee","378":"a594137d","403":"dac5ed6c","440":"b6339cd8","596":"f1a3e2df","607":"e7cdbc1c","652":"5e125aa8","764":"a1de7a68","938":"885b97a9"}[chunkId] + ".chunk.js";
};